// import React, { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { selectIsStorageUse, selectIsWebSearch, setIsStorageUse, setIsWebSearch } from '../ChatApp/chatSlice';

// const ToggleSwitchStorageUse = () => {
//     const dispatch = useDispatch()
//   const isStorageUse = useSelector(selectIsStorageUse)

//   const handleToggle = () => {
//     dispatch(setIsStorageUse(!isStorageUse));
//   };

//   return (
//     <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px', borderRadius: '10px', backgroundColor: '#fff', padding: '5px 7px' }}>
//       {/* Надпись слева */}
//       <span style={{ fontSize: '12px', marginRight: '10px', color: '#000' }}>Использовать при запросах</span>

//       {/* Переключатель */}
//       <div
//         onClick={handleToggle}
//         style={{
//           width: '60px',
//           height: '30px',
//           backgroundColor: isStorageUse ? '#E0E0E0' : '#fff', // светлый фон при включении
//           borderRadius: '30px',
//           border: '1px solid #000',
//           padding: '5px',
//           display: 'flex',
//           justifyContent: isStorageUse ? 'flex-end' : 'flex-start',
//           cursor: 'pointer',
//           transition: 'background-color 0.3s, justify-content 0.3s',
//         }}
//       >
//         <div
//           style={{
//             width: '20px',
//             height: '20px',
//             backgroundColor: isStorageUse ? '#05278b' : '#000', // синий кружок при включении
//             borderRadius: '50%',
//             transition: 'background-color 0.3s, transform 0.3s',
//           }}
//         ></div>
//       </div>
//     </div>
//   );
// };

// export default ToggleSwitchStorageUse;


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsStorageUse, selectStorageFiles, setIsStorageUse } from '../ChatApp/chatSlice';

const ToggleSwitchStorageUse = () => {
  const dispatch = useDispatch();
  const isStorageUse = useSelector(selectIsStorageUse);
  const storageFiles = useSelector(selectStorageFiles); // Получаем файлы из Redux

  // Автоматически выключаем toggle если хранилище стало пустым
  useEffect(() => {
    if ((!storageFiles || storageFiles.length === 0) && isStorageUse) {
      dispatch(setIsStorageUse(false));
    }
  }, [storageFiles, isStorageUse, dispatch]);

  // Проверяем, есть ли файлы в хранилище
  const isStorageEmpty = !storageFiles || storageFiles.length === 0;
  const isDisabled = isStorageEmpty;

  const handleToggle = () => {
    if (!isDisabled) {
      dispatch(setIsStorageUse(!isStorageUse));
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      marginLeft: '8px',
      borderRadius: '10px',
      backgroundColor: '#fff',
      padding: '5px 7px',
      opacity: isDisabled ? 0.5 : 1
    }}>
      {/* Надпись слева */}
      <span style={{ fontSize: '12px', marginRight: '10px', color: '#000' }}>
        {isDisabled ? 'Хранилище пусто' : 'Использовать при запросах'}
      </span>

      {/* Переключатель */}
      <div
        onClick={handleToggle}
        style={{
          width: '60px',
          height: '30px',
          backgroundColor: isStorageUse && !isDisabled ? '#E0E0E0' : '#fff',
          borderRadius: '30px',
          border: '1px solid #000',
          padding: '5px',
          display: 'flex',
          justifyContent: isStorageUse && !isDisabled ? 'flex-end' : 'flex-start',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.3s, justify-content 0.3s',
        }}
      >
        <div
          style={{
            width: '20px',
            height: '20px',
            backgroundColor: isDisabled ? '#999' : (isStorageUse ? '#05278b' : '#000'),
            borderRadius: '50%',
            transition: 'background-color 0.3s, transform 0.3s',
          }}
        ></div>
      </div>
    </div>
  );
};

export default ToggleSwitchStorageUse;